import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistFR() {
  const articleData = {
    title: 'Votre ex est-il un narcissique caché ? (Les textes ne mentent pas)',
    description: 'Vous vous demandez si votre ex est un narcissique caché ? Découvrez 7 comportements manipulateurs subtils que notre IA détecte instantanément dans les SMS.',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Rédaction Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: "Qu'est-ce qu'un narcissique caché et comment diffère-t-il des narcissiques ouverts ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Les narcissiques cachés dissimulent leurs comportements manipulateurs derrière du charme, des tactiques émotionnelles subtiles et des messages passifs-agressifs, contrairement aux narcissiques évidents et ouverts.'
      }
    }, {
      '@type': 'Question',
      name: "L'IA peut-elle détecter le narcissisme caché dans les SMS ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Oui. Toxic Detector analyse le ton, la culpabilisation, les cycles de love-bombing, l'incohérence et les schémas de manipulation émotionnelle pour signaler le comportement narcissique caché."
      }
    }, {
      '@type': 'Question',
      name: 'Quels sont les comportements courants des narcissiques cachés dans les textes ?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Manipulation émotionnelle, gaslighting, commentaires passifs-agressifs, jouer la victime, love-bombing suivi de retrait, et contrôle subtil.'
      }
    }, {
      '@type': 'Question',
      name: "Comment puis-je me protéger d'un narcissique caché ?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Documentez les messages, faites confiance à votre instinct, maintenez des limites et utilisez des outils comme Toxic Detector pour identifier objectivement les schémas manipulateurs.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/fr/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Lien copié dans le presse-papiers !');
    }
  };
  return <>
      <MetaTags title="Votre ex est-il un narcissique caché ? Comment l'IA détecte la manipulation | ToxicDetector" description="Vous vous demandez si votre ex est un narcissique caché ? Découvrez 7 comportements manipulateurs subtils que notre IA détecte instantanément." keywords="signes narcissique caché, comportement narcissique dissimulé, manipulation narcissique textes, détecteur narcissique IA" canonical={`https://toxicdetector.com/fr/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-5344" data-mp="14q9lb9r56xkn" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-5345" data-mp="17ypzj96pbd4u">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-5346" data-mp="t9ttfho7ga6v">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-5347" data-mp="y7vcw3pjmbiv">
            <div className="flex items-center justify-between" data-id="element-5348" data-mp="y6bwmd3w00h3">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-5349" data-mp="1lzaiq6gj3ayv">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Partager l'article" data-id="element-5350" data-mp="1cw9c84nr3huo">
                <Share2 size={20} className="text-gray-600" data-id="element-5351" data-mp="1h2rqrnr5ta8" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-5352" data-mp="5hmqfznz54yh">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-5353" data-mp="3u4kp8aoh2ekj">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-5354" data-mp="7yxnrolrb2z1" />
            Retour au Blog
          </Link>

          <header className="mb-12" data-id="element-5355" data-mp="3bf4g4yyq1dsi">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-5356" data-mp="3bg61pxdd5ioh">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-5357" data-mp="3l4xq5vj7tkun">
              <time dateTime={articleData.publishDate} data-id="element-5358" data-mp="3l70r3alwoye5">
                {new Date(articleData.publishDate).toLocaleDateString('fr-FR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-5359" data-mp="2np0m9jbc4sep">•</span>
              <span data-id="element-5360" data-mp="3de7esqu1v5cu">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-5361" data-mp="3hf9et9vsjlfv">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="Femme analysant des SMS montrant des signes de manipulation narcissique cachée avec l'IA" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-5362" data-mp="3he7s285exaib" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-5363" data-mp="2ugwhvcvw4o0k">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-5364" data-mp="2ygx3bhhepzh4">
              Table des Matières
            </h2>
            <ul className="space-y-3 text-sm" data-id="element-5365" data-mp="33hkwo9t3ysei">
              <li data-id="element-5366" data-mp="38eusq8b062bb">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5367" data-mp="38fdy6pjguy8g">
                  <span className="text-gray-400" data-id="element-5368" data-mp="nnapu83qe8ab">→</span> 1. Manipulation
                  émotionnelle dans chaque message
                </a>
              </li>
              <li data-id="element-5369" data-mp="237l6jlfxlizs">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5370" data-mp="2371n20amumjn">
                  <span className="text-gray-400" data-id="element-5371" data-mp="1thrtsh41yxty">→</span> 2. Gaslighting qui
                  s'accumule lentement
                </a>
              </li>
              <li data-id="element-5372" data-mp="1phhnf3ccm5ek">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5373" data-mp="1pdk4ahprtduo">
                  <span className="text-gray-400" data-id="element-5374" data-mp="1fjtixloxxjj7">→</span> 3. Commentaires
                  passifs-agressifs
                </a>
              </li>
              <li data-id="element-5375" data-mp="39w9v134f3rvz">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5376" data-mp="39uozpbaa44x2">
                  <span className="text-gray-400" data-id="element-5377" data-mp="2dr1g2lrq27ci">→</span> 4. Jouer la victime
                  constamment
                </a>
              </li>
              <li data-id="element-5378" data-mp="2isie89itnfpe">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5379" data-mp="24yzhyu54l35e">
                  <span className="text-gray-400" data-id="element-5380" data-mp="28yi0xkddz45l">→</span> 5. Love-Bombing puis
                  retrait
                </a>
              </li>
              <li data-id="element-5381" data-mp="200fweuug1tdk">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5382" data-mp="200pl8f3r5uho">
                  <span className="text-gray-400" data-id="element-5383" data-mp="1q0yrwgqxhlj6">→</span> 6. Contrôle caché et
                  surveillance
                </a>
              </li>
              <li data-id="element-5384" data-mp="3gc1w7ijr5gme">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-5385" data-mp="3kfri2091lk3q">
                  <span className="text-gray-400" data-id="element-5386" data-mp="18q1t0s5fefva">→</span> 7. Ton incohérent
                  entre les canaux
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-5387" data-mp="1ijiqc64rud3p">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-5388" data-mp="1dr92cvn7vn42">
              Avez-vous déjà eu l'impression que votre ex vous manipulait en
              coulisses, tout en paraissant charmant et attentionné ? Ce sont
              des <strong data-id="element-5389" data-mp="1ngsm03ir7kzz">signes classiques d'un narcissique caché</strong>.
              Contrairement aux narcissiques évidents, les cachés dissimulent
              leur manipulation derrière des tactiques émotionnelles subtiles.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-5390" data-mp="732dmkklqakj">
              Notre <strong data-id="element-5391" data-mp="7557jfovknuj">IA détecte la manipulation cachée</strong>{' '}
              instantanément en analysant leurs textes. Voici comment.
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-5392" data-mp="1cnbemt5spxti">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5393" data-mp="17nf9urp9y2cw">
                1️⃣ Manipulation émotionnelle dans chaque message
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5394" data-mp="13noesbspt02k">
                Les narcissiques cachés tordent les émotions pour obtenir ce
                qu'ils veulent.
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5395" data-mp="1veug2vk693tf">
                <p className="italic text-gray-700 text-lg" data-id="element-5396" data-mp="1rd99fry8dlro">
                  "Je ne peux pas croire que tu sois contrarié pour ça..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5397" data-mp="1hkjxkvyrq5vt">
                L'IA détecte la culpabilisation subtile et la pression
                émotionnelle cachée dans les messages quotidiens.
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-5398" data-mp="2hl5cl7jgqnf0">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5399" data-mp="2hmq5ksq4pyar">
                2️⃣ Gaslighting qui s'accumule lentement
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5400" data-mp="2rithgqas9baw">
                <p className="italic text-gray-700 text-lg" data-id="element-5401" data-mp="2vlg329gv1zzn">
                  "Tu te souviens mal de ça..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5402" data-mp="30jhv3jw9l9n9">
                Les narcissiques cachés vous font douter de votre propre
                mémoire. L'IA signale les cas répétés où la réalité est
                déformée.
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-5403" data-mp="3f7m7y78myqy4">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5404" data-mp="3jb0znv5xsvre">
                3️⃣ Commentaires passifs-agressifs
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5405" data-mp="3o9veyn4p426r">
                <p className="italic text-gray-700 text-lg" data-id="element-5406" data-mp="1o7m5r1pl43ov">
                  "Bien sûr, tout ce qui te rend heureux..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5407" data-mp="1xxfg5zdzqcrj">
                L'agressivité passive est une marque de fabrique du narcissisme
                caché. L'IA reconnaît le sarcasme, les piques sournoises et
                l'hostilité masquée.
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-5408" data-mp="22x1ru4e67ky8">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5409" data-mp="22yl83uzttw00">
                4️⃣ Jouer la victime constamment
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5410" data-mp="2by8dsszl9nyv">
                <p className="italic text-gray-700 text-lg" data-id="element-5411" data-mp="mj1vt4ig4fg9">
                  "Après tout ce que j'ai fait pour toi..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5412" data-mp="2t698ibinh8pv">
                Les narcissiques cachés retournent souvent la faute, se faisant
                passer pour la victime. L'IA détecte les phrases conçues pour
                vous culpabiliser.
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-5413" data-mp="2ofatrgdb8ioq">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5414" data-mp="2odpytpn32xqc">
                5️⃣ Love-Bombing puis retrait
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5415" data-mp="2ffdz8y48oplr">
                <p className="italic text-gray-700 text-lg" data-id="element-5416" data-mp="21flav9g6qlgy">
                  "Tu es la seule personne que j'ai jamais aimée 😢" → ghosting
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5417" data-mp="3vt4g75ggj8ct">
                Ce cycle classique d'affection intense suivi de distance
                émotionnelle est un signal d'alarme. L'IA identifie ces schémas
                à travers plusieurs chats.
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-5418" data-mp="364yxy06xpdvc">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5419" data-mp="365ia109wl81g">
                6️⃣ Contrôle caché et surveillance
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5420" data-mp="2w7arwe3vojxv">
                <p className="italic text-gray-700 text-lg" data-id="element-5421" data-mp="2s4xqu302ta7f">
                  "Je vérifiais juste... encore"
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5422" data-mp="2ncwcmbjcl9er">
                Le contrôle subtil déguisé en attention est une tactique cachée.
                L'IA signale les comportements de vérification répétés sans
                agression ouverte.
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-5423" data-mp="28gf3lqyms6vd">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5424" data-mp="24go6l5iiguie">
                7️⃣ Ton incohérent entre les canaux
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-5425" data-mp="jzx2x1aulbhf">
                <p className="italic text-gray-700 text-lg" data-id="element-5426" data-mp="o10jxr4mtdk8">
                  Chat de groupe : joueur / 1:1 : critique
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-5427" data-mp="xw0wcsdwdfsu">
                Les narcissiques cachés masquent souvent leur comportement
                publiquement tout en manipulant en privé. L'IA compare les
                conversations pour mettre en évidence les divergences.
              </p>
            </section>

            <section className="mb-12" data-id="element-5428" data-mp="a5odwnl100o0">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5429" data-mp="eyzq748lx9nb">
                🛡 Comment vous protéger
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-5430" data-mp="3dnyfs1eqyxcl">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-5431" data-mp="3im9scjwfflyi">
                  <li className="flex items-start gap-3" data-id="element-5432" data-mp="3amn0mmp2x4kn">
                    <span className="text-purple-600 font-bold" data-id="element-5433" data-mp="3al2790ei3rod">•</span>
                    <span data-id="element-5434" data-mp="36ki85radadzl">
                      Faites confiance à votre instinct. N'ignorez pas les
                      signaux d'alarme.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-5435" data-mp="3femsrsywqt6o">
                    <span className="text-purple-600 font-bold" data-id="element-5436" data-mp="2ro0yd4htt7f5">•</span>
                    <span data-id="element-5437" data-mp="2roanyqyylckb">Gardez des captures d'écran pour la clarté.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-5438" data-mp="2no8jyb5r471v">
                    <span className="text-purple-600 font-bold" data-id="element-5439" data-mp="31mgob454aan2">•</span>
                    <span data-id="element-5440" data-mp="2wn3svv06jv8v">
                      Partagez votre expérience avec des amis ou un thérapeute.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-5441" data-mp="guem1yfvzm9x">
                    <span className="text-purple-600 font-bold" data-id="element-5442" data-mp="bxeflmf4khia">•</span>
                    <span data-id="element-5443" data-mp="bz8xssz0hvio">
                      Utilisez des outils comme Toxic Detector pour identifier
                      les schémas.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-5444" data-mp="1kuuyae58ylm7">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-5445" data-mp="1kw640ji963fy">
                💀 Voyez-le de vos propres yeux
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-5446" data-mp="2djjsrubsrsoz">
                Le narcissisme caché peut être difficile à repérer, mais l'IA ne
                manque rien. Téléchargez vos chats et obtenez une analyse
                instantanée :
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-5447" data-mp="28r8tmtovsaxh">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-5448" data-mp="2whcxn25zecp0">
                  "🚩 78% manipulation détectée. Tactiques cachées identifiées
                  !"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-5449" data-mp="116vdfmudobv5">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-5450" data-mp="117n18bhqh5av">
                Questions Fréquentes
              </h2>
              <div className="space-y-4" data-id="element-5451" data-mp="rf8xjd73hom2">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-5452" data-mp="mhyxz4pzrwki" data-mpi={index}>
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-5453" data-mp="1f536vks7gv1k">
                      <span data-id="element-5454" data-mp="1a8csr2zyo9is">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-5455" data-mp="163v9r61fe092" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-5456" data-mp="3qucgaisluzmr">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-5457" data-mp="2fd9mgirnf030">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-5458" data-mp="2k484pnw7688w">
              💀 Prêt à découvrir la vérité ?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-5459" data-mp="2p2jfc0ubgms6">
              Arrêtez de deviner. Téléchargez vos textes sur Toxic Detector et
              obtenez un score de toxicité instantané. Notre IA révèle la
              manipulation cachée que vous auriez pu manquer.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-5460" data-mp="332u7r8b9y9fg">
              <p className="font-bold text-xl" data-id="element-5461" data-mp="13rt5yle68zsh">
                "🚩 78% manipulation détectée. Tactiques cachées identifiées !"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-5462" data-mp="sje12c6aq1xy">
              Scannez vos chats maintenant →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: '7 Signes de Gaslighting que Notre IA Détecte Instantanément',
          description: "Apprenez les principaux schémas de gaslighting que l'IA détecte dans vos conversations textuelles.",
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: 'Le Guide Ultime des Textes Passifs-Agressifs',
          description: 'Repérez le comportement passif-agressif et la manipulation cachée dans les SMS.',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-5463" data-mp="1778uxvw1iccm" />

          <div className="mt-12 text-center" data-id="element-5464" data-mp="293wophxn4rr4">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-5465" data-mp="24bdcaoaow2nw">
              <Share2 size={18} className="mr-2" data-id="element-5466" data-mp="1vbgvf8ujk83e" />
              Partager cet article
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-5467" data-mp="2s06e31dzt4qf">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-5468" data-mp="2nzmezs9uzr1n">
            <p className="text-gray-500 text-sm" data-id="element-5469" data-mp="2ny1ms9b0ok6y">
              © {new Date().getFullYear()} ToxicDetector. Tous droits réservés.
            </p>
          </div>
        </footer>
      </div>
    </>;
}